import CheckBoxInput from 'app/components/Form/CheckBoxInput';
import DatePicker from 'app/components/Form/Inputs/DatePicker';
import RadioButtonInput from 'app/components/Form/Inputs/RadioButtonInput';
import ReactSelectAutocomplete from 'app/components/Form/Inputs/ReactSelectAutocomplete';
import SelectInput from 'app/components/Form/Inputs/SelectInput';
import TextareaInput from 'app/components/Form/Inputs/TextareaInput';
import TextInput from 'app/components/Form/Inputs/TextInput';
import ToggleButton from 'app/components/ToggleButton';
import { _t } from 'app/utils/i18n';
import React, { FunctionComponent } from 'react';
import {
  daysOfWeekOptions,
  intervalsOptions,
  mothOptions,
} from 'reports/utils/constants';

import styles from './SecheduleReport.module.scss';

interface Props {
  onChange: (name: string, value: any) => void;
  values: any;
  register: any;
  errors: any;
  setError: any;
  control: any;
  trigger: any;
  clearErrors: () => void;
}

const SecheduleReport: FunctionComponent<Props> = ({
  onChange,
  values,
  register,
  control,
  errors,
  trigger,
  clearErrors,
}) => {
  return (
    <div className={styles.SecheduleReport}>
      <div className={styles.Wrapper}>
        <div className={styles.Wrapper__Title}>
          <span>{_t('reports:schedule_report')}</span>

          <ToggleButton
            value={values?.schedule_status}
            onChange={(event: any) => {
              onChange('schedule_status', event.target?.checked);
              if (!event.target?.checked) {
                clearErrors();
              } else {
                // trigger();
                onChange('days', values?.days);
              }
            }}
          />
        </div>
        <TextInput
          label={_t('reports:email_subject')}
          name="email_subject"
          error={errors?.email_subject?.message}
          register={register}
          disabled={!values?.schedule_status}
          required
        />
        <ReactSelectAutocomplete
          label={_t('reports:send_to') + '*'}
          withControl
          name="recipients"
          placeholder=" "
          control={control}
          value={values?.recipients}
          error={errors}
          isMulti
          isCreatable={!Array.isArray(errors?.recipients)}
          isEdit
          isDisabled={!values?.schedule_status}
        />
        <ReactSelectAutocomplete
          label={_t('reports:CC')}
          withControl
          name="recipients_cc"
          placeholder=" "
          control={control}
          value={values?.recipients_cc}
          error={errors}
          isMulti
          isCreatable={!Array.isArray(errors?.recipients_cc)}
          isEdit
          isDisabled={!values?.schedule_status}
        />
        <ReactSelectAutocomplete
          label={_t('reports:BCC')}
          withControl
          name="recipients_bcc"
          placeholder=" "
          control={control}
          value={values?.recipients_bcc}
          error={errors}
          isMulti
          isCreatable={!Array.isArray(errors?.recipients_bcc)}
          isEdit
          isDisabled={!values?.schedule_status}
        />
        <TextareaInput
          label={_t('reports:description') + '*'}
          rows={4}
          register={register}
          name="schedule_description"
          error={errors?.schedule_description?.message}
          disabled={!values?.schedule_status}
        />
        <div className={styles.Wrapper__FormatIntervals}>
          {/* <div>
            <CheckBoxInput
              name="format"
              register={register}
              options={formatsOptions}
              defaultValue={values?.format}
              label={_t('reports:format') + '*'}
              error={errors}
              disabled={!values?.schedule_status}
              OptionsISBlocked
            />
          </div> */}
          <div>
            <RadioButtonInput
              name="intervals"
              options={intervalsOptions}
              defaultValue={values?.intervals}
              label={_t('reports:intervals') + '*'}
              OptionsISBlocked
              error={errors}
              onChange={(event) => {
                onChange('intervals', event.value);
                onChange('days', null);
                onChange('day_of_month', '');
              }}
              disabled={!values?.schedule_status}
            />
          </div>
        </div>
        <div>
          {values?.intervals === 'DAILY' && (
            <CheckBoxInput
              name="days"
              register={register}
              options={daysOfWeekOptions}
              defaultValue={values?.days}
              label={_t('reports:days_of_Week') + '*'}
              error={errors}
              disabled={!values?.schedule_status}
              value={false}
            />
          )}
          {values?.intervals === 'WEEKLY' && (
            <RadioButtonInput
              name="days"
              options={daysOfWeekOptions}
              defaultValue={values?.days}
              label={_t('reports:days_of_Week') + '*'}
              error={errors}
              onChange={(event) => {
                onChange('days', event.value);
              }}
              disabled={!values?.schedule_status}
            />
          )}

          {values?.intervals === 'MONTHLY' && (
            <div className={styles.Intervals}>
              <SelectInput
                withValidations
                options={mothOptions}
                label={_t('reports:day_of_month') + '*'}
                name="day_of_month"
                control={control}
                error={errors?.day_of_month?.message}
                isEdit
                value={values?.day_of_month}
                disabled={!values?.schedule_status}
              />
            </div>
          )}
          <div className={`${styles.Intervals} mt-10 pt-10`}>
            <DatePicker
              label={_t('reports:data_from') + '*'}
              name="start_date"
              onChange={(val) => onChange('start_date', val)}
              value={values.start_date}
              error={errors}
              minDate={new Date()}
              isClearButton
              disabled={!values?.schedule_status}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecheduleReport;
